export const ACTION_TYPE = {//操作项
    STATE:          'state',//开关
    PLANNED_BUDGET: 'plannedBudget',//计划预算
    RELEASE_DATE:   'releaseDate',//投放日期
    TODAY_BUDGET:   'todayBudget',//当日预算
    TOMORROW_BUDGET:   'tomorrowBudget',//次日预算
    RELEASE_PERIOD:   'releasePeriod',//投放时段
    BASE_PRICE: 'basePrice',//基础出价
    SECOND_PRICE: 'secondPrice',//二阶出价
    THIRD_PRICE:'thirdPrice',//三阶出价
};
export const ACTION_TYPE_LIST = [
    { value: ACTION_TYPE.STATE, label:'开关' },
    { value: ACTION_TYPE.PLANNED_BUDGET, label:'计划预算' },
    { value: ACTION_TYPE.RELEASE_DATE, label:'投放日期' },
    { value: ACTION_TYPE.TODAY_BUDGET, label:'当日预算' },
    { value: ACTION_TYPE.TOMORROW_BUDGET, label:'次日预算' },
    { value: ACTION_TYPE.RELEASE_PERIOD, label:'投放时段' },
    { value: ACTION_TYPE.BASE_PRICE, label:'基础出价' },
    { value: ACTION_TYPE.SECOND_PRICE, label:'二阶出价' },
    { value: ACTION_TYPE.THIRD_PRICE, label:'三阶出价' },
]
// 需要提交给后端的类型值
export const ACTION_TYPE_DATA = {
    [ACTION_TYPE.STATE]: '1',
    [ACTION_TYPE.PLANNED_BUDGET]: '2',
    [ACTION_TYPE.RELEASE_DATE]: '3',
    [ACTION_TYPE.TODAY_BUDGET]: '4',
    [ACTION_TYPE.TOMORROW_BUDGET]: '5',
    [ACTION_TYPE.RELEASE_PERIOD]: '6',
    [ACTION_TYPE.BASE_PRICE]: '7',
    [ACTION_TYPE.SECOND_PRICE]: '8',
    [ACTION_TYPE.THIRD_PRICE]: '9',
};
// 反转类型值
export const ACTION_TYPE_REVERSAL_DATA = Object.keys(ACTION_TYPE_DATA).reduce((pre, key)=> {
    pre[ACTION_TYPE_DATA[key]] = key;
    return pre;
},{});
export const GROUP_TYPE = {
    PLAN:       '1',//计划
    ADV_TEAM:   '2',//广告组
    ADV:        '3',//广告
    ORI:        '4',//创意
};
export const PLAT_TYPE = {
    OPPO:     1,
    VIVO:     3,
    HW:       4,
    HW_ADS:   10,
    RY:       11,
    MI:       7
}
export const ACT_MATRIX = {
    [PLAT_TYPE.OPPO]:  {//OPPO
        [GROUP_TYPE.PLAN]: [ ACTION_TYPE.STATE, ACTION_TYPE.PLANNED_BUDGET ],
        [GROUP_TYPE.ADV_TEAM]: [ ACTION_TYPE.STATE,ACTION_TYPE.RELEASE_DATE,ACTION_TYPE.RELEASE_PERIOD ,ACTION_TYPE.BASE_PRICE, ACTION_TYPE.SECOND_PRICE, ACTION_TYPE.THIRD_PRICE],
    },
    [PLAT_TYPE.VIVO]:  {//vivo
        [GROUP_TYPE.PLAN]: [ ACTION_TYPE.STATE],
    },
    [PLAT_TYPE.HW]:  {//华为
        [GROUP_TYPE.PLAN]: [ ACTION_TYPE.STATE, ACTION_TYPE.PLANNED_BUDGET, ACTION_TYPE.RELEASE_DATE, ACTION_TYPE.RELEASE_PERIOD],
    },
    [PLAT_TYPE.HW_ADS]:  {//华为Ads
        [GROUP_TYPE.PLAN]: [ ACTION_TYPE.STATE, ACTION_TYPE.PLANNED_BUDGET],
    },
    [PLAT_TYPE.RY]:  {//荣耀
        [GROUP_TYPE.PLAN]: [ ACTION_TYPE.STATE],
    },
    [PLAT_TYPE.MI]:  {//小米
        [GROUP_TYPE.PLAN]: [ ACTION_TYPE.STATE],
    }
};
// 是否不限
export const LIMIT_TYPE = {
    LIMIT:      1,//限制
    NO_LIMIT:   0,//不限
    LIMIT_DATE: 2,//限制日期 投放日期 指定开始日期
}
// 筛选类型
export const SCREEN_TYPE = {
    ACCOUNT: '1',//账户
    PLAN: '2',//计划
    AD_GROUP: '3',//广告组
    AD: '4',//广告
    CREATIVE: '5',//创意
}
export const SCREEN_TYPE_LIST = [
    { value: SCREEN_TYPE.PLAN, label: '指定计划' },
    { value: SCREEN_TYPE.AD_GROUP, label: '指定广告组' },
    { value: SCREEN_TYPE.AD, label: '指定广告' },
    { value: SCREEN_TYPE.CREATIVE, label: '指定创意' },
    { value: SCREEN_TYPE.ACCOUNT, label: '指定账户' },
];
export const PLAT_SCREEN_TYPE_LIST = {
    [PLAT_TYPE.OPPO]: SCREEN_TYPE_LIST.filter(v=>{
        return ![ SCREEN_TYPE.CREATIVE ].includes(v.value)
    }),
    [PLAT_TYPE.VIVO]: SCREEN_TYPE_LIST,
    [PLAT_TYPE.HW]: SCREEN_TYPE_LIST.filter(v=> {
        return ![ SCREEN_TYPE.AD, SCREEN_TYPE.CREATIVE ].includes(v.value)
    }),
    [PLAT_TYPE.HW_ADS]: SCREEN_TYPE_LIST.filter(v=>{
        return ![ SCREEN_TYPE.CREATIVE ].includes(v.value)
    }),
    [PLAT_TYPE.RY]: SCREEN_TYPE_LIST.filter(v=>{
        return ![ SCREEN_TYPE.CREATIVE ].includes(v.value)
    }),
    [PLAT_TYPE.MI]: [
        { value: SCREEN_TYPE.PLAN, label: '指定计划' },
        { value: SCREEN_TYPE.AD_GROUP, label: '指定广告组' },
        { value: SCREEN_TYPE.AD, label: '指定创意' },
        { value: SCREEN_TYPE.ACCOUNT, label: '指定账户' },
    ],
}
// 计算预算限制
export const PLAT_PLANNED_BUDGET_TYPE = {
    [PLAT_TYPE.OPPO]:   { min:200, max: 10000 },
    [PLAT_TYPE.VIVO]:   { min:200, max: 10000 },
    [PLAT_TYPE.HW]:     { min:500, max: 10000 },
    [PLAT_TYPE.HW_ADS]: { min:500, max: 10000 },
    [PLAT_TYPE.MI]:     { min:200, max: 10000 },
}
// 调整类型
export const ADJUST_TYPE = {
    DECREASE: 'decrease',//降低
    INCREASE: 'increase',//提高
    ADJUST: 'adjust',//调整至
}
// 调整类型列表
export const ADJUST_TYPE_LIST = [
    { value: ADJUST_TYPE.DECREASE, label: '降低' },
    { value: ADJUST_TYPE.INCREASE, label: '提高' },
    { value: ADJUST_TYPE.ADJUST, label: '调整至' },
];

// 调整类型值
export const ADJUST_VALUE_TYPE = {
    FIXED: 'fixed',//固定
    PERCENTAGE: 'percentage',//百分比
}
// 调整类型值列表
export const ADJUST_VALUE_TYPE_LIST = [
    { value: ADJUST_VALUE_TYPE.FIXED, label: '固定' },
    { value: ADJUST_VALUE_TYPE.PERCENTAGE, label: '百分比' },
]

